class VlibasManager {
	/** @param {boolean} showLateralButton  */
	constructor(showLateralButton) {
		/**
		 * @private
		 * @type {boolean}
		 * - set default vlibras statement when page load
		 */
		this._currentState = false

		/**
		 * @private
		 * @type {HTMLDivElement}
		 */
		this.vlibrasContainer = document.getElementById('vlibras-container')

		/**
		 *
		 * @type {vlibrasCallback[]}
		 * @private
		 */

		this.vlibrasCallback = []

		this.currentState = !!showLateralButton
	}

	/**
	 * @param {boolean} state - set vlibras state
	 */
	set currentState(state) {
		this._currentState = !!state

		this.vlibrasContainer.className = this._currentState
			? 'enabled'
			: 'disabled'
	}

	/**
	 * @returns {boolean} returns vlibreas state
	 */
	get currentState() {
		return this._currentState
	}

	/**
	 *
	 * @param {vlibrasCallback} callback
	 */
	runWhenChangeState(callback) {
		if (typeof callback == 'function') {
			callback(this._currentState)
			this.vlibrasCallback.push(callback)
		}
	}
	/**
	 * @private
	 */
	_deployCallbacks() {
		this.vlibrasCallback.forEach((cb) => {
			try {
				cb(this._currentState)
			} catch (error) {
				console.log('erro ao executar callback vlibras', error)
			}
		})
	}
}

/**
 * @typedef {(state:boolean) => void} vlibrasCallback
 */
// import vlibras from 'https://vlibras.gov.br/app/vlibras-plugin.js'

// INSTANCE VLIBRAS HERE
const vlibasManager = classInstancer(VlibasManager, false)
